export const it = {
    translation: {
        b: {
            cancel: 'Annulla',
            confirm: 'Conferma',
            send: 'Invia',
            done: 'Fatto',
            close: 'Chiudi',
            clear: 'Pulisci',
            copy_link: 'Copia link',
            export: 'Esporta',
            delete: 'Elimina',
            delete_confirm: 'Conferma eliminazione',
            duplicate: 'Duplica',
            share: 'Condividi',
            sign_in: 'Accedi',
            sign_up: 'Registrati',
            email_address: 'Indirizzo email',
            yes: 'Sì',
            no: 'No'
        },
        m_languages: {
            title: 'Lingue',
            subtitle: 'Scegli una lingua'
        },
        m_feedback: {
            feature: {
                name: 'Richiesta funzionalità',
                desc: 'Manca una funzionalità di cui hai bisogno? Faccelo sapere — le tue idee contano'
            },
            feedback: {
                name: 'Feedback',
                desc: 'Il tuo feedback è molto importante per noi — lascia un breve messaggio'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Grazie per il tuo suggerimento!',
                desc: 'Apprezziamo davvero il tempo che hai dedicato a condividere le tue idee — ci aiuta a migliorare.'
            },
            feedback: {
                name: 'Grazie per il tuo feedback!',
                desc: 'Apprezziamo davvero il tempo che hai dedicato a condividere le tue idee — ci aiuta a migliorare.'
            }
        },
        m_diagram_details: {
            name_place: 'Inserisci il nome del progetto',
            desc_place: 'Inserisci la descrizione del progetto'
        },
        m_quick_share: {
            title: 'Condivisione rapida',
            subtitle: '(Tramite link)'
        },
        m_export_img: {
            title: 'Esporta immagine'
        },
        m_export_code: {
            title: 'Esporta codice {{db_engine}}',
            download_file: 'Scarica file',
            copy_code: 'Copia codice'
        },
        m_sign_in_remind: {
            title: 'Grazie per aver provato DB Design',
            subtitle: 'Accedi o registrati per aumentare il numero massimo di tabelle, salvare i diagrammi e sbloccare altre funzionalità.'
        },
        m_sign_in_restrict: {
            title: 'Accedi per fare di più nell’app',
            subtitle: 'Accedi o registrati per aumentare i limiti di tabelle, salvare i diagrammi e sbloccare più funzionalità.'
        },
        m_new_diagram: {
            title: 'Nuovo diagramma',
            subtitle: 'Scegli un motore di database',
            open_diagram: 'Apri diagramma'
        },
        m_keyboard_shortcuts: {
            title: 'Scorciatoie da tastiera',
            ctrl_left: {
                title1: 'Controlli',
                title2: '(Sinistra)',
                items: {
                    mouse_sel: 'Selezione con mouse / Modalità mano',
                    table: 'Tabella',
                    line: 'Linea',
                    area: 'Area',
                    note: 'Nota',
                    comment: 'Commento',
                    pen: 'Matita',
                    undo: 'Annulla',
                    redo: 'Ripristina'
                }
            },
            ctrl_top_left: {
                title1: 'Controlli',
                title2: '(In alto a sinistra)',
                items: {
                    export_img: 'Esporta immagine',
                    search: 'Cerca',
                    editor_panel: 'Pannello editor'
                }
            },
            ctrl_bottom_right: {
                title1: 'Controlli',
                title2: '(In basso a destra)',
                items: {
                    minimap: 'Minimappa',
                    zoom_in: 'Zoom avanti',
                    zoom_out: 'Zoom indietro',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu contestuale',
                title2: '(Tabella)',
                items: {
                    dupl_tab: 'Duplica tabella',
                    del_tab: 'Elimina tabella'
                }
            },
            ctx_del_tab: {
                title1: 'Menu contestuale',
                title2: '(Elimina tabella)',
                items: {
                    yes: 'Sì',
                    no: 'No'
                }
            },
            ctx_tab_col: {
                title1: 'Menu contestuale',
                title2: '(Colonna)', // (Colonna della tabella)
                items: {
                    add_col_below: 'Aggiungi colonna sotto',
                    focus_col_above: 'Porta il focus alla colonna sopra',
                    focus_col_below: 'Porta il focus alla colonna sotto',
                    move_col_up: 'Sposta colonna in alto',
                    move_col_down: 'Sposta colonna in basso',
                    dupl_col: 'Duplica colonna',
                    del_col: 'Elimina colonna'
                }
            },
            ctx_line: {
                title1: 'Menu contestuale',
                title2: '(Linea)',
                items: {
                    del_line: 'Elimina linea'
                }
            },
            ctx_area: {
                title1: 'Menu contestuale',
                title2: '(Area)',
                items: {
                    dupl_area: 'Duplica area',
                    del_area: 'Elimina area'
                }
            },
            ctx_multi: {
                title1: 'Menu contestuale',
                title2: '(Selezione multipla)',
                items: {
                    select_all: 'Seleziona tutti gli elementi',
                    create_area_for_select_els: 'Crea area per gli elementi selezionati',
                    dupl_select_els: 'Duplica elementi selezionati',
                    del_select_els: 'Elimina elementi selezionati'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Selezione con mouse',
                table: 'Tabella',
                line: 'Linea',
                area: 'Area',
                note: 'Nota (presto)',
                comment: 'Commento (presto)',
                pen: 'Matita',
                undo: 'Annulla',
                redo: 'Ripristina'
            },
            ctrl_top_left: {
                logo: 'Nota: questo è un sandbox (area di test)',
                name: 'Informazioni sul diagramma',
                editor: 'Editor (presto)',
                search: 'Ricerca (presto)',
                export: 'Opzioni di esportazione',
                view_mode: 'Modalità di visualizzazione',
                zoom_to_fit: 'Adatta allo schermo'
            },
            ctrl_top_right: {
                feature_req: 'Richiesta funzionalità',
                sign_in: 'Accedi',
                quick_share: 'Condivisione rapida'
            },
            ctrl_bottom_right: {
                full_screen: 'Schermo intero',
                minimap: 'Minimappa',
                zoom_out: 'Zoom indietro',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Zoom avanti',
                info: 'Informazioni e risorse'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Predefinito',
                        blue: 'Blu',
                        green: 'Verde',
                        red: 'Rosso',
                        purple: 'Viola',
                        violet: 'Violetto'
                    },
                    borders: {
                        none: 'Nessuno',
                        solid: 'Continuo',
                        dashed: 'Tratteggiato',
                        dotted: 'Punteggiato'
                    },
                    color: 'Colore',
                    border: 'Bordo',
                    description: 'Descrizione',
                    description_table_place: 'Descrizione tabella',
                    description_column_place: 'Descrizione colonna',
                    description_line_place: 'Descrizione linea',
                    description_note_place: 'Descrizione nota',
                    description_area_place: 'Descrizione area',
                    description_pen_place: 'Descrizione matita',
                    hide_menu: 'Nascondi menu',
                    show_menu: 'Mostra menu'
                },
                tab_col: {
                    add_col_below: 'Aggiungi colonna sotto',
                    add_col_above: 'Aggiungi colonna sopra',
                    key: 'Key',
                    keys: {
                        none: 'Nessuna',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Nessuno',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Sposta colonna in basso',
                    move_col_up: 'Sposta colonna in alto',
                    more_functions: 'Altre funzioni'
                },
                line: {
                    change_connects: 'Modifica connettori',
                    connects: {
                        empty: 'Vuoto',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtra elementi'
                },
                multi: {
                    filter: 'Filtra selezione',
                    create_area: 'Crea area'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Completo',
            keys_only: 'Solo chiavi',
            names_only: 'Solo nomi'
        },
        dropdown_ctrl_export: {
            export_img: 'Esporta immagine',
            export_code: 'Esporta codice SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Accedi',
            new_project: 'Nuovo progetto',
            keyboard_shortcuts: 'Scorciatoie da tastiera',
            languages: 'Lingue'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Feedback',
            keyboard_shortcuts: 'Scorciatoie da tastiera',
            languages: 'Lingue',
            homepage: 'Pagina iniziale'
        },
        n: {
            default: 'Caricamento…',
            file_ready_to_download: 'Il file è pronto per il download',
            code_copied: 'Il codice è stato copiato',
            link_copied: 'Il link è stato copiato',
            please_enter_message: 'Inserisci un messaggio',
            invalid_email: 'Email non valida',
            something_wrong_contact: 'Qualcosa è andato storto. Ricarica la pagina o contattaci.',
            something_wrong: 'Qualcosa è andato storto. Ricarica la pagina.',
            sending: 'Invio…',
            request_sent: 'La richiesta è stata inviata. Grazie!'
        }
    }
};

export const itMeta = {
    lang_origin: 'Italiano',
    lang_eng: 'Italian',
    lang_code: 'it',
};
